module.exports = __webpack_public_path__ + "static/media/n-53-shot-02-mobile.5a9e0459.webp";